import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import SimuladorNumericInput from "./SimuladorNumericInput";
import { truncar } from "../../Helpers/Truncar";

export const SimuladorIncentivoAnualOR = ({ rango = null, sueldo = 0 }) => {
    const [state, setState] = useState({
        real: 0,
        meta: 0,
        cumplimiento: 0,
        porcentaje: 0,
        incentivo: 0,
    });
    const handleChange = ({ target }) => {
        setState({
            ...state,
            [target.name]: target.value,
        });
    };

    useEffect(() => {
        if (Number(state.meta !== 0) && Number(state.real !== 0)) {
            const cumplimiento = truncar((Number(state.real) / Number(state.meta)) * 100);
            var porcentaje = 0;
            var incentivo = 0;
            if (rango !== null) {
                rango.forEach((index) => {
                    if (index.minimo <= cumplimiento && index.maximo >= cumplimiento) {
                        porcentaje = index.porcentaje;
                        incentivo =
                            (Number(sueldo)) * index.porcentaje;
                    }
                });
            }

            setState({
                ...state,
                cumplimiento,
                porcentaje: porcentaje * 100,
                incentivo,
            });
        }
    }, [state.meta, state.real, sueldo]);
    return (
        <div className="simulador-incentivo-anual-input">
            <div className="input-section">
                <div>Utilidad Anual</div>
                <SimuladorNumericInput
                    name="real"
                    label=""
                    value={state.real}
                    disabled={false}
                    onChange={handleChange}
                />
            </div>
            <div className="input-section">
                <div>Objetivo de Utilidad</div>
                <SimuladorNumericInput
                    name="meta"
                    label=""
                    value={state.meta}
                    disabled={false}
                    onChange={handleChange}
                />
            </div>
            <div className="input-section">
                <div>Cumplimiento de venta</div>
                <SimuladorNumericInput
                    name="cumplimiento"
                    label=""
                    value={state.cumplimiento}
                    disabled={true}
                    icono="porcentaje"
                    align="centro"
                />
            </div>
            <div className="input-section">
            </div>
            <div className="input-section">
                <div>Tu incentivo es de:</div>
                <SimuladorNumericInput
                    name="incentivo"
                    label=""
                    value={state.incentivo}
                    disabled={true}
                    icono="pesos"
                    inputTotal="si"
                />
            </div>
        </div>
    );
};
